import { render, staticRenderFns } from "./LandingStock.vue?vue&type=template&id=4e54d3f9&scoped=true"
import script from "./LandingStock.vue?vue&type=script&lang=js"
export * from "./LandingStock.vue?vue&type=script&lang=js"
import style0 from "./LandingStock.vue?vue&type=style&index=0&id=4e54d3f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54d3f9",
  null
  
)

export default component.exports